import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { stateMapper, StyledText, StyledTextarea, StyledLabel, StyledMsgBox } from './Textarea.styled';

const Textarea = ({ name, label, value, required, success, errorMessage, onChange, onBlur }) => (
  <ThemeProvider theme={{ ...stateMapper[success && 'success'], ...stateMapper[errorMessage && 'error'] }}>
    <StyledText className="textarea">
      <StyledTextarea
        value={value}
        placeholder={`${label}${required ? '*' : ''}`}
        id={name}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
      />
      <StyledLabel filled={!!value} htmlFor={name}>{`${label}${required ? '*' : ''}`}</StyledLabel>
      <StyledMsgBox>{errorMessage}</StyledMsgBox>
    </StyledText>
  </ThemeProvider>
);

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  success: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

Textarea.defaultProps = {
  label: '',
  value: '',
  required: false,
  success: false,
  errorMessage: '',
  onChange: () => {},
  onBlur: () => {},
};

export default Textarea;
